/**
* Component BackToTop
*
* Display a button to back to top.
*
* Method : 
* scrollToTop : when the button is clicked, the window is scroll at a position
* handleScroll : the button display after x seconds
*
* Events : 
* mounted : listen the event "handleScroll"
* beforeUnmount : cover the button with the method "handleScroll"
*/

<template>
    <button
    v-show="showButton"
    @click="scrollToTop"
    class="back-to-top">
  
</button>
 </template>
 
 <script>
 export default {
    name: 'BackToTop',
    data(){
        return{
            showButton: false
        };
    },
    methods:{
        scrollToTop(){
            window.scrollTo({top:0, behavior:"smooth"});
        },
        handleScroll(){
            this.showButton = window.scrollY > 300; // Afficher après 300px de défilement
        }
    },
    mounted(){
        addEventListener("scroll", this.handleScroll)
    },
    beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

 <style lang="scss">
 @import "../assets/styles/_variables.scss";

 .back-to-top {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 3rem;
  height: 3rem;
  background: $third-color;
  color: white;
  border: none;
  border-radius: 80% !important;
  cursor: pointer;
  box-shadow: 0 0 .5rem 0 rgba(0,0,0,.3);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  padding-bottom: .75rem;
  transition: transform 0.3s ease, opacity 0.3s ease-in-out;
  z-index: 1000;
  opacity: 0.8;
  padding-left: 1.5rem;
  padding-right: 1.5rem;  
}

.back-to-top:hover {
  transform: scale(1.15);
  opacity: 1;
}

/* Style de la flèche */
.back-to-top::before {
  content: "↑";
  font-weight: bold;
}

@media (max-width: 768px) {
  .back-to-top{
    bottom: 1rem;
    right: 1rem;
      border-radius: 50% !important;
    width: 2.5rem;
    height: 2.5rem;
    font-size: 1rem;
  }
  }
 </style>